import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';

import {
  RouteTabGroupComponent,
  TabGroupConfig,
} from '@features/tab-group/route-tab-group.component';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { injectFlags } from '@shared/services/launch-darkly.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouteTabGroupComponent, RouterOutlet],
  template: `
    <div class="mb-6">
      <aux-route-tab-group [tabs]="tabs" [variant]="'button'" />
    </div>

    <router-outlet></router-outlet>
  `,
})
export class CloseSettingsComponent {
  flags = injectFlags({
    balanceSheetAccounts: 'balance_sheet_accounts',
    expenseDefaults: 'expense_defaults',
    settingsJournalEntryConfiguration: 'settings_journal_entry_configuration',
  });

  tabs: TabGroupConfig[] = [
    {
      label: 'Expense Source Defaults',
      route: ROUTING_PATH.SETTINGS.CLOSE_SETTINGS.EXPENSE_DEFAULTS,
      show: toObservable(computed(() => this.flags().expenseDefaults)),
    },
    {
      label: 'Journal Entry Configuration',
      route: ROUTING_PATH.SETTINGS.CLOSE_SETTINGS.JE_CONFIGURATION,
      show: toObservable(computed(() => this.flags().settingsJournalEntryConfiguration)),
    },
    {
      label: 'Balance Sheet Accounts',
      route: ROUTING_PATH.SETTINGS.CLOSE_SETTINGS.BALANCE_SHEET_ACCOUNTS,
      show: toObservable(computed(() => this.flags().balanceSheetAccounts)),
    },
  ];
}
